<template>

  <section class="how section" id="how">

    <div class="container">

      <div class="row">

        <div class="heading col-12">
          <h3>Apps, websites, enterprise software. <br /><strong class="color-2">We do it all</strong></h3>
            <h4 class="legend">We work with design conscious and fashion forward clients, from the very beginning – including, concept ideation, design execution, interactive prototypes, and everything in between. </h4>
        </div>

        <div class="goals">
            <div class="goals__list">
                <section class="goals__item">
                    <h6 class="goals__item-heading"><span class="text sys-ops-fo">you</span></h6>
                    <ul class="goals__item-list">
                        <li class="goals__item-goal">Budget</li>
                        <li class="goals__item-goal">Backlog</li>
                        <li class="goals__item-goal">Test - Fast failing</li>
                        <li class="goals__item-goal">Domain knowledge</li>
                        <li class="goals__item-goal">Business knowledge</li>
                    </ul>
                </section>
                <section class="goals__item">
                    <h6 class="goals__item-heading"><span class="text sys-ops-fo">the product</span></h6>
                </section>
                <section class="goals__item">
                    <h6 class="goals__item-heading "><span class="text sys-ops-fo">us</span></h6>
                    <ul class="goals__item-list">
                        <li class="goals__item-goal">Design</li>
                        <li class="goals__item-goal">Software architecture</li>
                        <li class="goals__item-goal">QA</li>
                        <li class="goals__item-goal">Automation</li>
                        <li class="goals__item-goal">App development</li>
                    </ul>
                </section>
            </div>
        </div>

      </div>

    </div>

  </section>

</template>

<script>
export default {
  name: 'How',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style scoped>

.how {
  background-color: #1b1b1e;
}

.goals {
  padding-top: 4vw;
  padding-bottom: 4vw;
  width:100%;
}
@media all and (max-width: 768px) {
  .goals {
    width: 80%;
    margin: 0 auto;
  }
}

.goals * {
    box-sizing: inherit;
    color:white;
}
.goals__list {
    position: relative;
    z-index: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-flow: row nowrap;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -webkit-box-pack: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    align-content: center;
    max-width: 1360px;
    margin: 0 auto
}
.goals__list:before,
.goals__list:after {
    content: "";
    position: absolute;
    z-index: -1;
    top: -60px;
    width: 35.5%;
    height: 320px;
    border: 2px dotted #f39005;
    overflow: visible;
}
.goals__list:before {
    left: 180px
}
.goals__list:after {
    right: 180px
}
.goals__item {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 33.3%;
    flex: 1 1 33.3%
}
.goals__item:first-child {
    text-align: left
}
.goals__item:not(:first-child):not(:last-child) {
  display:flex;
  justify-content: center;
  align-content: center;
}
.goals__item:last-child {
    text-align: right
}
.goals__item-heading {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -moz-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-flex-flow: row nowrap;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    align-content: center;
    width: 200px;
    height: 200px;
    margin: 0 auto;
    border: 2px dotted #f39005;
    background-image: linear-gradient(to bottom, #23252c, #342c2d);
    font-size: .9rem;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 300;
}
.goals__item-heading img.hackdagio-vertical-logo {
  width: 3em;
}
.goals__item-heading img.hackdagio-horizontal-logo {
  width: 7em;
}
.goals__item-list {
    position: absolute;
    top: 0px;
    width: 200px;
    margin: 0;
    overflow: hidden;
    list-style: none
}
.goals__item:first-child .goals__item-list {
    left: 230px
}
.goals__item:last-child .goals__item-list {
    right: 230px
}
.goals__item-goal {
    display: block;
    margin: 0 0 .55em;
    font-size: 18px;
    opacity: .8
}
.section-goals {
    margin: 0 0 75px;
    padding: 75px 0 30px
}
.section-goals .dtcell {
    padding-top: 35px
}
.section-goals .goals {
    padding: 195px 0 0
}
.section-goals .section-title {
    padding: 0 5%
}
@media screen and (max-width: 1366px) {
    .goals__list {
        padding: 0
    }
    .goals__list:before,
    .goals__list:after {
        width: 37%
    }
    .goals__list:before {
        left: 100px
    }
    .goals__list:after {
        right: 100px
    }
    .goals__item-heading {
        width: 150px
    }
    .goals__item:first-child .goals__item-list {
        left: 170px
    }
    .goals__item:last-child .goals__item-list {
        right: 170px
    }
}
@media only screen and (min-width: 768px) and (max-width: 1024px),
only screen and (max-width: 767px) {
    .goals__list {
        display: block;
        padding: 0
    }
    .goals__list:before,
    .goals__list:after {
        display: none
    }
    .goals__item {
        text-align: center;
        margin: 20px 0
    }
    .goals__item:first-child {
        text-align: center
    }
    .goals__item:last-child {
        padding: 0 0 62px;
        text-align: center
    }
    .goals__item:first-child:before,
    .goals__item:last-child:before {
        content: "";
        position: absolute;
        z-index: -1;
        width: auto;
        left: 30px;
        right: 30px;
        border: 2px dotted #75767a;
    }
    .goals__item:first-child:before {
        top: 45px;
        bottom: -40px
    }
    .goals__item:last-child:before {
        top: -40px;
        bottom: 45px
    }
    .goals__item-heading {
        width: 170px;
        height: 62px;
        font-size: 16px
    }

    .goals__item:last-child .goals__item-heading {
        position: absolute;
        bottom: 0;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -moz-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        -o-transform: translate(-50%, 0);
        transform: translate(-50%, 0)
    }
    .goals__item-list {
        position: static;
        width: 100%;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-flex-flow: column nowrap;
        -ms-flex-flow: column nowrap;
        flex-flow: column nowrap;
        -webkit-box-pack: flex-start;
        -webkit-justify-content: flex-start;
        -ms-flex-pack: flex-start;
        justify-content: flex-start;
        -webkit-box-align: flex-start;
        -webkit-align-items: flex-start;
        -ms-flex-align: flex-start;
        align-items: flex-start;
        align-content: flex-start
    }
    .goals__item:first-child .goals__item-list {
        margin-top: 20px
    }
    .goals__item:last-child .goals__item-list {
        margin-bottom: 20px
    }
    .goals__item-goal {
        width: 100%
    }
    .goals__item-goal:last-child {
        margin-bottom: 0
    }
    .goals__item:first-child .goals__item-goal:first-child {
        margin-bottom: 0
    }
    .goals__item:first-child .goals__item-goal:last-child {
        margin-bottom: .55em
    }
    .goals__item:first-child .goals__item-goal:nth-child(1) {
        order: 10
    }
    .goals__item:first-child .goals__item-goal:nth-child(2) {
        order: 9
    }
    .goals__item:first-child .goals__item-goal:nth-child(3) {
        order: 8
    }
    .goals__item:first-child .goals__item-goal:nth-child(4) {
        order: 7
    }
    .goals__item:first-child .goals__item-goal:nth-child(5) {
        order: 6
    }
    .goals__item:first-child .goals__item-goal:nth-child(6) {
        order: 5
    }
    .goals__item:first-child .goals__item-goal:nth-child(7) {
        order: 4
    }
    .goals__item:first-child .goals__item-goal:nth-child(8) {
        order: 3
    }
    .goals__item:first-child .goals__item-goal:nth-child(9) {
        order: 2
    }
    .goals__item:first-child .goals__item-goal:nth-child(10) {
        order: 1
    }
    .section-goals {
        margin-bottom: 0;
        padding-top: 0;
        padding-bottom: 0
    }
    .section-goals .goals {
        padding-top: 50px
    }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .goals__list {
        width: 60%
    }
    .section-goals .dtcell {
        padding-top: 60px
    }
}
@media only screen and (max-width: 767px) {
    .goals__list {
        width: 100%
    }
    .goals__item-goal {
        font-size: 12px
    }
}
@media only screen and (min-width: 1024px)
{
    .goals__item-heading img.hackdagio-horizontal-logo
    {
      display:none!important;
    }
    .goals__item-heading img.hackdagio-vertical-logo
    {
      display:block!important;
    }
}

@media only screen and (max-width: 1023px)
{
    .goals__item-heading img.hackdagio-vertical-logo
    {
      display:none!important;
    }
    .goals__item-heading img.hackdagio-horizontal-logo
    {
      display:block!important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/How.vue